import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularDeposits: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_deposits"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="deposits icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M11.223 9C11.223 8.58579 11.5593 8.25 11.9741 8.25C12.389 8.25 12.7253 8.58579 12.7253 9V13.2981L13.7207 12.3893C14.0269 12.1098 14.502 12.1311 14.7819 12.4368C15.0619 12.7425 15.0406 13.2169 14.7344 13.4964L12.481 15.5535C12.194 15.8155 11.7543 15.8155 11.4673 15.5535L9.21387 13.4964C8.9077 13.2169 8.88643 12.7425 9.16635 12.4368C9.44628 12.1311 9.9214 12.1098 10.2276 12.3893L11.223 13.2981V9Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2591 5.75V19H21.2489C21.6637 19 22 19.3358 22 19.75C22 20.1642 21.6637 20.5 21.2489 20.5L2.75114 20.5C2.3363 20.5 2 20.1642 2 19.75C2 19.3358 2.3363 19 2.75114 19H5.74006V5.75C5.74006 4.50736 6.74895 3.5 7.99348 3.5H16.0057C17.2502 3.5 18.2591 4.50736 18.2591 5.75ZM16.7568 19H7.24234V5.75C7.24234 5.33579 7.57864 5 7.99348 5H16.0057C16.4205 5 16.7568 5.33579 16.7568 5.75V19Z"
        />
      </svg>
    </span>
  );
};

export { RegularDeposits };
